module.exports = __webpack_public_path__ + "static/img/i2.fafa8bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i2.png
// module id = zVx9
// module chunks = 0